import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'pxw-icon[icon="chevron-down"],pxw-icon[icon="chevron-up"]',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['../icon/icon.component.scss'],
  providers: [{ provide: IconComponent, useExisting: IconChevronDownComponent }],
  template: `
    <svg viewBox="0 0 45 46" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.4175 18.2568L22.5 25.4324L15.5825 18.2568C15.4175 18.0856 15.2221 18 14.9963 18C14.7705 18 14.5751 18.0856 14.41 18.2568L12.2475 20.5C12.0825 20.6712 12 20.8739 12 21.1081C12 21.3423 12.0825 21.545 12.2475 21.7162L21.9138 31.7432C22.0788 31.9144 22.2742 32 22.5 32C22.7258 32 22.9212 31.9144 23.0862 31.7432L32.7525 21.7162C32.9175 21.545 33 21.3423 33 21.1081C33 20.8739 32.9175 20.6712 32.7525 20.5L30.59 18.2568C30.4249 18.0856 30.2295 18 30.0037 18C29.7779 18 29.5825 18.0856 29.4175 18.2568Z"
      />
    </svg>
  `,
})
export class IconChevronDownComponent extends IconComponent {}
